"use strict";

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.array.index-of.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.object.assign.js");

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.RocheExpansionPanel = void 0;

require("core-js/modules/es.array.join.js");

var _react = _interopRequireDefault(require("react"));

var _ExpansionPanel = _interopRequireDefault(require("@material-ui/core/ExpansionPanel"));

var _core = require("../core");

var _utils = require("../utils");

var _expansionPanel = require("./expansion-panel.styles");

var _excluded = ["classes"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * ⚠️ The ExpansionPanel component was renamed to Accordion to use a more common naming convention.
 *
 * You should use `import { RocheAccordion } from '@one/react-kit/accordion'`
 * or `import RocheAccordion from '@one/react-kit/accordion'`.
 */
var RocheExpansionPanel = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var classes = _ref.classes,
      rest = _objectWithoutProperties(_ref, _excluded);

  // *** DEPRECATION NOTICE ***
  if (process.env.NODE_ENV !== 'production') {
    console.warn(['Roche React Kit: The component RocheExpansionPanel has been deprecated in favor of RocheAccordion', "Please, import it as `import { RocheAccordion } from '@one/react-kit/accordion'`"].join('\n'));
  } // **************************


  var innerClasses = (0, _utils.mergeClasses)((0, _expansionPanel.useStyles)(), classes);
  return /*#__PURE__*/_react["default"].createElement(_ExpansionPanel["default"], _extends({
    classes: innerClasses,
    ref: ref
  }, rest));
});

exports.RocheExpansionPanel = RocheExpansionPanel;
RocheExpansionPanel.displayName = (0, _core.rochePrefix)('ExpansionPanel');
RocheExpansionPanel.defaultProps = {};
var _default = RocheExpansionPanel;
exports["default"] = _default;